import { nothing } from 'lit';

export function triStateButtonsPartTemplate() {
  return nothing;
}
